import { motion } from "framer-motion";

import Navbar from "./Navbar";
import Footer from "./Footer";
import FogOverlay from "./FogOverlay";
import WindDust from "./WindDust";
import PageMeta from "./PageMeta";
import RichText from "../i18n/RichText";
import { useLanguage } from "../i18n/LanguageContext";

const ComingSoon = ({ title, description }) => {
  const { t } = useLanguage();

  return (
    <>
      <PageMeta noindex />
      <div className="relative w-full h-dvh overflow-hidden bg-black flex items-center justify-center bg-home before:absolute before:inset-0 before:content-[''] z-0 before:bg-black/50">
        <Navbar />
        <FogOverlay />

        <motion.div
          style={{ zIndex: 30 }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex flex-col items-center gap-y-3 px-10 text-center"
        >
          <h1 className="barrio-regular text-[#FFEDD6] leading-none text-[40px] 2xl:text-[60px]">
            {title ?? (
              <RichText
                text={t("comingSoon.title")}
                highlightClass="text-[#FF6355]"
              />
            )}
          </h1>
          <div className="didot-bold text-[#FFEDD6] text-sm 2xl:text-xl max-w-md">
            {description ?? t("comingSoon.description")}
          </div>
        </motion.div>

        <WindDust />
      </div>

      <Footer />
    </>
  );
};

export default ComingSoon;
